import React, { useState } from 'react';
import logo from '../assets/SousPal.svg';
import './TopMenuBar.css';

function TopMenuBar(props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu visibility

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="top-menu-bar">
      <nav>
        <div className="logo">
          <img src={logo} height="50px" alt="SousPal Logo" />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
  {isMenuOpen ? (
    <span className="close-icon">✖️</span> // Change to 'X' when open
  ) : (
    <>
      <div className="line"></div>
      <div className="line"></div>
      <div className="line"></div>
    </>
  )}
</div>

        <ul className={`menu-items ${isMenuOpen ? 'open' : ''}`}>                                      
          <li><a href="/">Home</a></li>
          <li><a href="/features">Features</a></li>
          <li><a href="/about">About</a></li>
          <li><a href="/contact">Contact</a></li>
        </ul>
        <div className='login'>
          { props.user ? 
            <p>Welcome, {props.user}</p> : 
            <button className="notify-btn">Log In</button>
          }
        </div>
      </nav>
    </div>
  );
}

export default TopMenuBar;